import { render } from "./AddTypeTaxeModal.vue?vue&type=template&id=760f65fc&ts=true"
import script from "./AddTypeTaxeModal.vue?vue&type=script&lang=ts"
export * from "./AddTypeTaxeModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__